import { render, staticRenderFns } from "./FtpDialog.vue?vue&type=template&id=cb1065ec&scoped=true&"
import script from "./FtpDialog.vue?vue&type=script&lang=js&"
export * from "./FtpDialog.vue?vue&type=script&lang=js&"
import style0 from "./FtpDialog.vue?vue&type=style&index=0&id=cb1065ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1065ec",
  null
  
)

export default component.exports